<template>
  <div class="order-group-detail">
    <div class="total-info">
      <div class="box1">
        <p>订单编号：{{ detail.order_number }}</p>
        <p>团编号：{{ detail.group_bn }}</p>
        <p>昵称：{{ detail.nickname }} / {{ detail.mobile }}</p>
        <p>下单时间：{{ detail.created_at | tsFormatLong }}</p>
        <p>支付类型：{{ detail.pay_type_name }}</p>
        <p>商品类型：{{ detail.shop_type_name }}</p>
      </div>
      <div class="box2">
        <div class="time-line">
          <div class="item" v-for="(value, name, index) in curTimelineData" :key="index">
            <p class="label">{{ index + 1 }}.{{ value.title }}</p>
            <i class="circle" :class="{ active: value.active }"></i>
            <p class="time">{{ value.time }}</p>
          </div>
        </div>
        <div class="desc">
          <Icon type="ios-information-circle-outline" size="35" color="#f49015" />
          <div class="text">
            <p class="abstruct">{{ timelineDesc.abstruct }}</p>
            <p class="info">{{ timelineDesc.info }}</p>
            <div class="btn-wrap" v-if="detail.descData.id == 1">
              <Button type="text" @click="onCancel">取消订单</Button>
              <Button type="text" @click="onChangePrice">改价</Button>
            </div>
            <div class="btn-wrap" v-if="detail.descData.id == 3 || detail.descData.id == 13">
              <Button type="text" @click="onDelivery">发货</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="detail.is_virtual == 2" class="delivery-info">
      <div class="receiver-info">
        <p class="label">收货人信息：</p>
        <p class="info">收货人：{{ detail.consignee }}</p>
        <p class="info">手机号：{{ detail.consignee_mobile }}</p>
        <p class="info">收货地址：{{ address }}</p>
        <p class="info">买家留言：{{ detail.remark }}</p>
      </div>
      <div class="logistics-info">
        <p class="label">配送信息：</p>
        <p class="info">配送方式：{{ detail.ship_status == 2 ? "无需发货" : "普通快递" }}</p>
        <p class="info">配送时间：{{ detail.ship_time_ts }}</p>
        <p class="info">快递公司：{{ detail.logistics_name }}</p>
        <p class="info">
          <span style="margin-right:10px;">快递单号：{{ detail.logistics_no }}</span>
        </p>
      </div>
    </div>
    <div class="price-info">
      <p class="label title">订单信息</p>
      <Table :columns="tableColumns" :data="tableDatas" border></Table>
      <div class="more">
        <p>
          商品总价：
          <currency :price="detail.price * detail.product_number"></currency>
        </p>
        <p>
          优惠券/优惠码：
          <currency :price="detail.coupon_discount"></currency>
        </p>
        <p>
          运费：
          <currency :price="detail.logistics_fee"></currency>
        </p>
        <p style="font-size:14px; font-weight:600;">
          <span>实收金额：</span>
          <currency :price="detail.order_price + detail.logistics_fee"></currency>
        </p>
      </div>
    </div>
    <change-price-ex-dlg
      v-model="changePriceDlgShow"
      :order-id="detail.order_id"
      :has-logistics="detail.is_virtual == 2"
      @on-ok="requestDetail"
    ></change-price-ex-dlg>
    <delivery-dlg v-model="deliveryDlgShow" :data="detail" @on-ok="requestDetail"></delivery-dlg>
  </div>
</template>

<script>
import { PayType, ShopType } from "@/utils/enums";
import ChangePriceExDlg from "./components/ChangePriceExDlg";
import DeliveryDlg from "./components/DeliveryDlg";
export default {
  name: "order-group-detail",
  components: {
    ChangePriceExDlg,
    DeliveryDlg
  },
  data() {
    return {
      detail: {
        descData: {}
      },
      timelineStep: 1,
      timelineData: {
        1: {
          title: "买家下单",
          active: false,
          time: "",
          abstruct: "买家已下单，等待付款",
          info: "如买家未在规定时间内付款，订单将按照设置逾期自动关闭",
          show: true
        },
        2: {
          title: "买家付款",
          active: false,
          time: "",
          abstruct: "买家已付款，等待成团",
          info:
            "如未在规定时间内成团，订单将按照设置自动关闭，且系统会自动原路退还该订单金额",
          show: true
        },
        3: {
          title: "买家成团",
          active: false,
          time: "",
          abstruct: "买家已成团，等待商家发货",
          info: "买家已成团，请尽快发货，否则买家有权申请退款",
          show: true
        },
        4: {
          title: "卖家发货",
          active: false,
          time: "",
          abstruct: "商家已发货，等待交易成功",
          info: "等待买家确认收货",
          show: true
        },
        5: {
          title: "交易成功",
          active: false,
          time: "",
          abstruct: "交易成功",
          show: true
        },
        99: {
          title: "交易关闭",
          active: false,
          time: "",
          abstruct: "交易关闭",
          info: "交易关闭",
          show: true
        }
      },
      tableColumns: [
        { title: "商品", key: "product_name", align: "left", minWidth: 250 },
        {
          title: "拼团单价(元)",
          key: "price_show",
          align: "center",
          minWidth: 100
        },
        {
          title: "数量",
          key: "product_number",
          align: "center",
          minWidth: 100
        },
        {
          title: "拼团优惠(元)",
          key: "discount_show",
          align: "center",
          minWidth: 100
        },
        {
          title: "小计(元)",
          key: "total_price_show",
          align: "center",
          minWidth: 100
        },
        {
          title: "状态",
          key: "order_status_name",
          align: "center",
          minWidth: 100
        }
      ],
      tableDatas: [],
      changePriceDlgShow: false,
      deliveryDlgShow: false
    };
  },
  created() {
    this.requestDetail();
  },
  computed: {
    address() {
      let ret = "";
      ret += this.detail.province_name || "";
      ret += this.detail.city_name || "";
      ret += this.detail.district_name || "";
      ret += this.detail.logistics_name || "";
      return ret;
    },
    timelineDesc() {
      let ret = {};
      if (this.timelineData[this.timelineStep]) {
        ret = this.timelineData[this.timelineStep];
      }
      return ret;
    },
    curTimelineData() {
      const ret = {};
      for (const key in this.timelineData) {
        if (this.timelineData[key].show) {
          ret[key] = this.timelineData[key];
        }
      }
      return ret;
    }
  },
  methods: {
    // on event
    onChangePrice() {
      this.changePriceDlgShow = true;
    },
    async onCancel() {
      await this.$promiseConfirm("取消订单后，该订单将会被关闭，是否确认？");
      await this.$http.put("/api/spellGroup/order/cancel", {
        order_id: this.detail.order_id
      });
      this.$Message.success("取消订单成功");
      this.requestDetail();
    },
    onDelivery() {
      this.deliveryDlgShow = true;
    },
    // other
    setTimelineStep(data) {
      // 初始化
      this.timelineStep = 1;
      for (const key in this.timelineData) {
        this.timelineData[key].show = true;
      }
      // 时间轴节点判断，虚拟物品没有3、4步，is_virtual 1:虚拟商品 2:实体商品
      if (data.created_at) {
        this.timelineStep = 1;
        this.timelineData[1].time = this.$pub.timestampToTime(data.created_at);
      }
      if (data.payed_time) {
        this.timelineStep = 2;
        this.timelineData[2].time = this.$pub.timestampToTime(data.payed_time);
      }
      if (data.group_succ_time && data.is_virtual == 2) {
        this.timelineStep = 3;
        this.timelineData[3].time = this.$pub.timestampToTime(
          data.group_succ_time
        );
      }
      if (data.ship_time && data.is_virtual == 2) {
        this.timelineStep = 4;
        this.timelineData[4].time = this.$pub.timestampToTime(data.ship_time);
      }
      if (data.order_finished_time) {
        this.timelineStep = 5;
        this.timelineData[5].time = this.$pub.timestampToTime(
          data.order_finished_time
        );
      }
      // 删除节点
      if (data.is_virtual != 2) {
        this.timelineData[3].show = false;
        this.timelineData[4].show = false;
      }
      // 设置active
      for (const key in this.timelineData) {
        if (key <= this.timelineStep) {
          this.timelineData[key].active = true;
        }
      }
      // 交易成功 / 交易关闭 处理
      if (data.order_status == 3) {
        // 如果交易关闭，将未激活的节点删除，并加入关闭节点
        this.timelineStep = 99;
        const tlData = this.timelineData[99];
        tlData.time = this.$pub.timestampToTime(data.updated_at);
        tlData.active = true;
        for (const key in this.timelineData) {
          if (!this.timelineData[key].active)
            this.timelineData[key].show = false;
        }
        // console.log(data.descData)
        switch (data.descData.id) {
          case 10:
            tlData.info = "买家已申请退款，退款成功，交易关闭";
            break;
          case 11:
            tlData.info =
              "未在规定时间内成团，交易关闭，系统会自动原路退还该订单金额";
            break;
          case 12:
            tlData.info = "买家未在规定时间内付款，交易关闭";
            break;
        }
      } else {
        this.timelineData[99].show = false;
      }
    },
    // request
    requestDetail() {
      this.$http
        .get(`/api/order/${this.$route.query.order_id}`, {
          is_spell: 1
        })
        .then(data => {
          // 获取desc
          data.spell_id = true; // 设置类型为拼团订单
          data.descData = this.$pub.order.getDescData(data);
          // console.log(data.descData);
          // 数据整理
          data.pay_type_name = PayType.getValue(data.pay_type);
          data.shop_type_name = ShopType.getValue(data.shop_type);
          data.price_show = this.$pub.calcPrice(data.price);
          data.product_price_show = this.$pub.calcPrice(data.product_price);
          data.total_price_show = this.$pub.calcPrice(
            data.price * data.product_number
          );
          data.discount_show = this.$pub.calcPrice(
            (data.product_price - data.price) * data.product_number
          );
          data.coupon_discount_show = this.$pub.calcPrice(data.coupon_discount);
          data.logistics_fee_show = this.$pub.calcPrice(data.logistics_fee);
          data.real_price_show = this.$pub.calcPrice(
            data.order_price + data.logistics_fee
          );
          data.order_status_name = data.descData.text.detail;
          data.ship_time_ts = data.ship_time
            ? this.$pub.timestampToTime(data.ship_time)
            : "";
          // 设置时间轴
          this.setTimelineStep(data);
          // 初始化数据
          this.detail = data;
          this.tableDatas = [];
          this.tableDatas.push(data);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.order-group-detail {
  .total-info {
    border: 1px solid #ddd;
    display: flex;
    overflow: hidden;
    .box1 {
      padding: 20px;
      border-right: 1px solid #ddd;
      min-width: 300px;
      line-height: 22px;
      color: #888;
    }
    .box2 {
      padding: 20px;
      .time-line {
        display: flex;
        .item {
          text-align: center;
          width: 150px;
          position: relative;
          .label {
            margin-bottom: 5px;
          }
          .circle {
            display: inline-block;
            width: 15px;
            height: 15px;
            border: 1px solid #bbb;
            border-radius: 50%;
            position: relative;
            &::after {
              content: "";
              display: block;
              width: 135px;
              height: 4px;
              background-color: #ddd;
              position: absolute;
              top: 50%;
              right: 14px;
              transform: translateY(-50%);
            }
            &.active {
              background-color: #2d8cf0;
              &::after {
                background: #2d8cf0;
              }
            }
          }
          &:first-child {
            i::after {
              display: none;
            }
          }
          .time {
            color: #888;
            white-space: nowrap;
          }
        }
      }
      .desc {
        margin-top: 20px;
        display: flex;
        .text {
          margin-left: 10px;
          .abstruct {
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 10px;
          }
          .info {
            margin-bottom: 10px;
          }
          .btn-wrap {
            .ivu-btn {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
  .delivery-info {
    border: 1px solid #c5c5c5;
    margin-top: 20px;
    display: flex;
    .label {
      font-size: 18px;
      font-weight: 500;
    }
    .info {
      line-height: 22px;
    }
    .receiver-info {
      padding: 20px;
      min-width: 300px;
      border-right: 1px solid #c5c5c5;
    }
    .logistics-info {
      padding: 20px;
    }
  }
  .price-info {
    margin-top: 20px;
    .label {
      font-size: 16px;
      font-weight: 500;
    }
    .more {
      float: right;
      margin-top: 10px;
      line-height: 22px;
      text-align: right;
    }
  }
}
</style>
